import { render } from "./FavouriteSpplierPage.vue?vue&type=template&id=0909dccc&lang=html"
import script from "./FavouriteSpplierPage.vue?vue&type=script&lang=js"
export * from "./FavouriteSpplierPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__